module.exports = __webpack_public_path__ + "static/media/bg.02db3f3b.jpg";